"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
var _typeof = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/typeof.js");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.weak-map");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
require("/Users/vagrant/git/node_modules/core-js/modules/es6.array.iterator.js");
require("/Users/vagrant/git/node_modules/core-js/modules/es6.promise.js");
require("/Users/vagrant/git/node_modules/core-js/modules/es6.object.assign.js");
require("/Users/vagrant/git/node_modules/core-js/modules/es7.promise.finally.js");
var _vue = _interopRequireDefault(require("vue"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
require("normalize.css/normalize.css");
var _elementUi = _interopRequireDefault(require("element-ui"));
var _ja = _interopRequireDefault(require("element-ui/lib/locale/lang/ja"));
require("./styles/element-variables.scss");
require("@/styles/index.scss");
var _app = _interopRequireDefault(require("firebase/app"));
var _App = _interopRequireDefault(require("./App"));
var _store = _interopRequireDefault(require("./store"));
var _router = _interopRequireDefault(require("./router"));
require("./icons");
require("./permission");
require("./utils/error-log");
var filters = _interopRequireWildcard(require("./filters"));
var _vueApollo = _interopRequireDefault(require("vue-apollo"));
var _apolloClient = require("@/apollo/apolloClient");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
// a modern alternative to CSS resets

// global css

// firebase
require('firebase/auth');

// icon
// permission control
// error log

// global filters

_vue.default.use(_vueApollo.default);
var apolloProvider = new _vueApollo.default({
  defaultClient: _apolloClient.apolloClient
});
_vue.default.use(_elementUi.default, {
  size: _jsCookie.default.get('FS_ClientSize') || 'medium',
  // set element-ui default size
  locale: _ja.default
});

// register global utility filters
Object.keys(filters).forEach(function (key) {
  _vue.default.filter(key, filters[key]);
});
_vue.default.config.productionTip = false;

// firebaseSDK
var firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_CONFIG_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_CONFIG_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_CONFIG_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_CONFIG_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_CONFIG_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_CONFIG_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_CONFIG_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_CONFIG_MEASUREMENT_ID
};
_app.default.initializeApp(firebaseConfig);
_app.default.auth().onAuthStateChanged(/*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(user) {
    return regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!user) {
            _context.next = 1;
            break;
          }
          _store.default.dispatch('auth/setFirebaseUser', user);
          _context.next = 2;
          break;
        case 1:
          _store.default.dispatch('auth/setFirebaseUser', []);
          _context.next = 2;
          return _app.default.auth().signOut();
        case 2:
          new _vue.default({
            el: '#app',
            router: _router.default,
            store: _store.default,
            apolloProvider: apolloProvider,
            render: function render(h) {
              return h(_App.default);
            }
          });
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());